import "animate.css";
import React from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";

const ValueCard = ({ point, index, styles }) => {


  const { ref, inView } = useInView({
    trackVisibility:false,
    triggerOnce: false,
    threshold: 0.1
  });

  const styledText = styleWords(point.text, styles);

  return (
    <div
      key={index}
      ref={ref}
      className="col-12 col-sm-6 col-lg-4 d-flex align-items-stretch m-1"
    >
      <div
        className={`card text-center shadow-sm w-100 h-100 ${
          inView ? "animate__animated animate__fadeInRight" : ""
        }`}
      >
        <div className="card-body d-flex flex-column justify-content h-100 p-4">
          <div className="mb-3">
            <img
              src={point.emoji}
              alt=""
              style={{
                width: "80px",
                height: "80px",
                objectFit: "contain"
              }}
            />
          </div>
          <p className="card-text text-start">{styledText}</p>
        </div>
      </div>
    </div>
  );
};

function styleWords(text, wordsToStyle) {
  const escapedWords = wordsToStyle.map(item =>
    item.word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  );
  const regex = new RegExp(`(${escapedWords.join("|")})`, "gi");
  const parts = text.split(regex);

  return parts.flatMap((part, index) => {
    if (!part) return null;
    const matchedWordObj = wordsToStyle.find(
      item => part && item.word.toLowerCase() === part.toLowerCase()
    );
    if (matchedWordObj) {
      return (
        <span key={index} style={matchedWordObj.style}>
          {part}
        </span>
      );
    }

    return part.split("\n").flatMap((line, i, arr) => [
      <React.Fragment key={`${index}-${i}`}>{line}</React.Fragment>,
      i !== arr.length - 1 ? <br key={`${index}-br-${i}`} /> : null
    ]);
  });
}

const ValueProposition = () => {
  const { t } = useTranslation();
  const bulletPoints = t("bulletPoints", { returnObjects: true });

  const styledSubtitle = styleWords(t("proposition_subtitle"), [
    { word: "support fiable", style: { fontWeight: "bold" } },
    { word: "sécurisé et francophone", style: { fontWeight: "bold" } },
    { word: "reliable, secure, and English/French-speaking support,", style: { fontWeight: "bold" } },
    { word: "local and international standards.", style: { fontWeight: "bold" } }
    
  ]);

  const styles = [
    { word: "Modèles économiques flexibles", style: { fontWeight: "bold" } },
    {
      word: "(ressources à temps partiel/temps plein, modèles onshore/offshore)",
      style: { fontWeight: "bold", color: "#0276c1" }
    },
    {
      word: "Tunisie : Destination nearshore, à moins de deux heures de vol",
      style: { fontWeight: "bold", color: "#0276c1" }
    },
    {
      word: "sans décalage horaire",
      style: { fontWeight: "bold", color: "#0276c1" }
    },
    {
      word: "vivier de talents qualifiés",
      style: { fontWeight: "bold", color: "#0276c1" }
    },
    {
      word: "en audit financier, audit IT, comptabilité, et opérations, ",
      style: { color: "#0276c1" }
    },
    { word: "montée en charge rapide,", style: { fontWeight: "bold" } },
    {
      word: "Gouvernance Rigoureuse & Equipes Expérimentées:",
      style: { fontWeight: "bold" }
    },
    {
      word:
        "Plus de 50 ans d’expérience cumulée des fondateurs et plus de 45,000 heures de prestations réalisées en 2024",
      style: { fontWeight: "bold", color: "#0276c1" }
    },
    {
      word:
        "(Canada, France, Belgique, Luxembourg, Suisse, Middle East, Irlande, Espagne...)",
      style: { fontWeight: "bold", color: "#0276c1" }
    },
    {
      word:
        "Management de proximité: Nous disposons déjà de bureaux au Luxembourg et au Canada",
      style: { fontWeight: "bold" }
    },
    {word:"Présence géographique:" ,style: { fontWeight: "bold" }},
    {
      word:
        "Flexible delivery models",
      style: { fontWeight: "bold" }
    },
     {
      word:
        "No minimum volume requirements",
      style: { fontWeight: "bold" }
    },

    {
      word:
        "part-time/full-time resources, onshore/offshore hybrid setups",
      style: { fontWeight: "bold", color: "#0276c1" }
    },
    {
      word:
        "Tunisia as a nearshore destination: less than two hours from most European capitals",
      style: { fontWeight: "bold", color: "#0276c1" }
    },
    {
      word:
        "Access to top talent ",
      style: { fontWeight: "bold" }
    },

    {
      word:
        "Rapid scalability,",
      style: { fontWeight: "bold" }
    },

    {
      word:
        "Strong governance & hands-on management:",
      style: { fontWeight: "bold" }
    },

    {
      word:
        "International presence:",
      style: { fontWeight: "bold" }
    },

    {
      word:
        "Local proximity:",
      style: { fontWeight: "bold" }
    },

  ];

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4 text-black">
        <strong>{t("proposition_title")}</strong>
      </h2>

      <h5 className="text-center mb-5">{styledSubtitle}</h5>

      <div className="row justify-content-center">
        {/* First row: 3 cards */}
        <div className="col-12 d-flex flex-wrap justify-content-center mb-4">
          {bulletPoints.slice(0, 3).map((point, index) => (
            <ValueCard key={index} point={point} index={index} styles={styles} />
          ))}
        </div>

        {/* Second row: 2 cards */}
        <div className="col-12 d-flex flex-wrap justify-content-center">
          {bulletPoints.slice(3).map((point, index) => (
            <ValueCard key={index + 3} point={point} index={index + 3} styles={styles} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ValueProposition;
